import Api from "./Api";

class PointrankingAPI extends Api{

    pointRanking10(){

        let path = "/Pointranking/top10";

        let endpoint =  this.combineUrl(this.apiHost,path);

        return this._get(endpoint).then(response =>  response)        
    }

}

let _api = new PointrankingAPI();

export default _api;